import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import BibleVerse from "@/components/BibleVerse";
import AboutSection from "@/components/AboutSection";
import LeadershipSection from "@/components/LeadershipSection";
import IntroVideo from "@/components/IntroVideo";
import ServiceTimes from "@/components/ServiceTimes";
import EventsCalendar from "@/components/EventsCalendar";
import Gallery from "@/components/Gallery";
import Newsletter from "@/components/Newsletter";
import ContactForm from "@/components/ContactForm";
import PrayerRequest from "@/components/PrayerRequest";
import DraggableHelpButton from "@/components/DraggableHelpButton";
import Footer from "@/components/Footer";

export default function HomePage() {
  return (
    <div className="min-h-screen" data-testid="home-page">
      <Header />
      <HeroSection />
      <BibleVerse />
      <AboutSection />
      <LeadershipSection />
      <IntroVideo />
      <ServiceTimes />
      <EventsCalendar />
      <Gallery />
      <Newsletter />
      <ContactForm />
      <PrayerRequest />
      <Footer />
      <DraggableHelpButton />
    </div>
  );
}
